import { SnackbarAlert } from '@global-engineering-shared/gweb-material-global';
import { Snackbar as MUISnackbar } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import SnackbarContent from 'components/SnackbarContent';
import { useSnackbar } from 'context/SnackbarProvider/SnackbarProvider';

const Snackbar = () => {
  const { snackbarInfo, setSnackbarInfo } = useSnackbar();
  const handleClose = () => {
    setSnackbarInfo({ ...snackbarInfo, open: false });
  };

  const { content, open, severity } = snackbarInfo;

  return (
    <MUISnackbar
      autoHideDuration={5000}
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      ClickAwayListenerProps={{ onClickAway: () => null }}
      onClose={handleClose}
    >
      <SnackbarAlert
        alertContent={<SnackbarContent header={content.header} message={content.message} />}
        enableDismiss
        severity={severity}
        onClose={handleClose}
      />
    </MUISnackbar>
  );
};

export default Snackbar;
